angular.module('rjmNg.controllers').controller "dimensionGridCtrl", [
  "$scope"
  "dimensionService"
  "utils"
  "app"
  ($scope, dimensionService, utils, app) ->
    $scope.rjqlVersion = app.getRjqlVersion()

    # Either a dictionary of boolean values in the form metricIndex: isEditable,
    # or null if all metrics are editable.
    if not $scope.editableMetricIndices?
      $scope.editableMetricIndices = null

    # Either a dictionary of boolean values in the form
    # dimensionIndex: isEditable, or null if all dimensions are editable.
    if not $scope.editableDimensionIndices?
      $scope.editableDimensionIndices = null

    # Whether the user should only be able to submit if they've changed something.
    if not $scope.forceEnableSubmit?
      $scope.forceEnableSubmit = false

    # Save this so we can only enable the submit button if something has
    # changed.
    $scope.originalMetrics = utils.copy($scope.metrics)

    $scope.canSubmit = false

    # Sets whether the 'Submit' button is enabled or disabled.
    # Submit is enabled when (every metric is either independent or all its
    # dimensions are non-null) and something has changed in some way.
    _updateCanSubmit = () ->
      if $scope.metrics? and $scope.metrics.length > 0
        for metric in $scope.metrics when not metric.independent
          for dim in metric.dimensions when not dim
            $scope.canSubmit = false
            return

      $scope.canSubmit = $scope.forceEnableSubmit or not angular.equals($scope.metrics, $scope.originalMetrics)

    $scope.$watch "metrics", (newMetrics, oldMetrics) ->

      # Update any metrics whose independence has changed.
      if newMetrics.length is oldMetrics.length and newMetrics.length > 1
        for newMetric, index in newMetrics when index > 0
          oldMetric = oldMetrics[index]
          if newMetric.independent isnt oldMetric.independent
            dimensionService.updateGridMetricDimensions(newMetrics[0], newMetric)

      _updateCanSubmit()

    , true

    $scope.close = () ->
      $scope.dismiss()
      if $scope.hideCallback?
        $scope.hideCallback($scope)

    $scope.submit = () ->
      $scope.dismiss()
      if $scope.submitCallback?
        $scope.submitCallback($scope)

]
